export const getOrigin = siteUrl => {
  try {
    return new URL(siteUrl).origin;
  } catch (er) {
    const a = document.createElement('a');
    a.setAttribute('href', siteUrl);
    return a.protocol + "//" + a.host;
  }
};
//# sourceMappingURL=get-origin.js.map